import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import noop from 'lodash/fp/noop';
import MenuItemComponent from './MenuItem';
const MenuItems = ({ items, closeMenu = noop, onMouseEnter = noop }) => {
    return (_jsx(_Fragment, { children: items.map((item, index) => (_jsx(MenuItemComponent, { ...item, index: item.index ?? index, closeMenu: closeMenu, onMouseEnter: onMouseEnter }, item.index ?? index))) }));
};
export default MenuItems;
